import { redux } from '@ohif/core';
import store from './../../store';
// import cornerstoneTools from 'cornerstone-tools';

const commandsModule = ({ commandsManager }) => {
  const { setViewportActive, setActiveViewportSpecificData } = redux.actions;
  const isActive = () => {
    const { viewer } = store.getState();
    if (
      viewer.activeButtonIds.length &&
      (viewer.activeButtonIds.indexOf('freehand') !== -1 ||
        viewer.activeButtonIds.indexOf('rect') !== -1)
    )
      return true;
    return false;
  };

  const actions = {
    updateActiveViewport: ({ viewports, direction, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const { viewportSpecificData, activeViewportIndex } = viewports;
          const maxIndex = Object.keys(viewportSpecificData).length - 1;

          let newIndex = activeViewportIndex + direction;
          newIndex = newIndex > maxIndex ? 0 : newIndex;
          newIndex = newIndex < 0 ? maxIndex : newIndex;

          store.dispatch(setViewportActive(newIndex));
        }
      } else {
        if (type === 'mark') return;
        const { viewportSpecificData, activeViewportIndex } = viewports;
        const maxIndex = Object.keys(viewportSpecificData).length - 1;

        let newIndex = activeViewportIndex + direction;
        newIndex = newIndex > maxIndex ? 0 : newIndex;
        newIndex = newIndex < 0 ? maxIndex : newIndex;

        store.dispatch(setViewportActive(newIndex));
      }
    },
    setWindowLevelPreset: ({ viewports, preset, type }) => {
      const state = store.getState();
      const { preferences = {} } = state;
      const { window, level } =
        preferences.windowLevelData && preferences.windowLevelData[preset];

      if (isActive()) {
        if (type === 'mark') {
          if (window && level) {
            commandsManager.runCommand('setWindowLevel', {
              viewports,
              window,
              level,
            });
          }
        }
      } else {
        if (type === 'mark') return;
        if (window && level) {
          commandsManager.runCommand('setWindowLevel', {
            viewports,
            window,
            level,
          });
        }
      }
    },
    updateViewportDisplaySet: ({ viewports, direction }) => {
      // if (isActive()) return;
      const viewportSpecificData = { ...viewports.viewportSpecificData };
      const activeViewport =
        viewportSpecificData[viewports.activeViewportIndex];
      const studyMetadata = utils.studyMetadataManager.get(
        activeViewport.StudyInstanceUID
      );

      if (!studyMetadata) {
        return;
      }

      const allDisplaySets = studyMetadata.getDisplaySets();
      const currentDisplaySetIndex = allDisplaySets.findIndex(
        displaySet =>
          displaySet.displaySetInstanceUID ===
          activeViewport.displaySetInstanceUID
      );
      if (currentDisplaySetIndex < 0) {
        return;
      }

      const newDisplaySetIndex = currentDisplaySetIndex + direction;
      const newDisplaySetData = allDisplaySets[newDisplaySetIndex];
      if (!newDisplaySetData) {
        return;
      }

      store.dispatch(setActiveViewportSpecificData(newDisplaySetData));
    },
    //lhwen add 自定义窗宽窗位按钮
    setWindowLevelByHotkey: ({ viewports, preset }) => {
      const dom = commandsManager.runCommand('getActiveViewportEnabledElement');
      const cornerstoneElement = cornerstone.getEnabledElement(dom);
      let { windowWidth, windowCenter } = cornerstoneElement.viewport.voi;
      if (preset === 1) {
        windowWidth = windowWidth + 1;
      }
      if (preset === 2) {
        windowWidth = windowWidth - 1;
      }
      if (preset === 3) {
        windowCenter = windowCenter + 1;
      }
      if (preset === 4) {
        windowCenter = windowCenter - 1;
      }
      let window = windowWidth.toString();
      let level = windowCenter.toString();
      commandsManager.runCommand('setWindowLevel', {
        viewports,
        window,
        level,
      });
    },
  };

  const definitions = {
    // Next/Previous active viewport
    incrementActiveViewport: {
      commandFn: actions.updateActiveViewport,
      storeContexts: ['viewports'],
      options: { direction: 1 },
    },
    decrementActiveViewport: {
      commandFn: actions.updateActiveViewport,
      storeContexts: ['viewports'],
      options: { direction: -1 },
    },
    // Window level Presets
    //lhwen add 自定义窗宽窗位按钮
    // windowLevelPreset8: {
    //   commandFn: actions.setWindowLevelPreset,
    //   storeContexts: ['viewports'],
    //   options: { preset: 8 },
    // },

    windowLevelPreset1: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 1 },
    },
    windowLevelPreset2: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 2 },
    },
    windowLevelPreset3: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 3 },
    },
    windowLevelPreset4: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 4 },
    },
    windowLevelPreset5: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 5 },
    },
    windowLevelPreset6: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 6 },
    },
    windowLevelPreset7: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 7 },
    },
    windowLevelPreset8: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 8 },
    },
    windowLevelPreset9: {
      commandFn: actions.setWindowLevelPreset,
      storeContexts: ['viewports'],
      options: { preset: 9 },
    },
    /**************************lhwen add 自定义窗宽窗位按钮****/
    markWindowLevelPreset1: {
      commandFn: actions.setWindowLevelByHotkey,
      storeContexts: ['viewports'],
      options: { preset: 1 },
    },
    markWindowLevelPreset2: {
      commandFn: actions.setWindowLevelByHotkey,
      storeContexts: ['viewports'],
      options: { preset: 2 },
    },
    markWindowLevelPreset3: {
      commandFn: actions.setWindowLevelByHotkey,
      storeContexts: ['viewports'],
      options: { preset: 3 },
    },
    markWindowLevelPreset4: {
      commandFn: actions.setWindowLevelByHotkey,
      storeContexts: ['viewports'],
      options: { preset: 4 },
    },
    /************************************* */

    nextViewportDisplaySet: {
      commandFn: actions.updateViewportDisplaySet,
      storeContexts: ['viewports'],
      options: { direction: 1 },
    },
    previousViewportDisplaySet: {
      commandFn: actions.updateViewportDisplaySet,
      storeContexts: ['viewports'],
      options: { direction: -1 },
    },
  };

  return {
    definitions,
    defaultContext: 'VIEWER',
  };
};

export default commandsModule;
